export const pagination = {
  entriesPrepend: "Zeige",
  entriesPerPage: "Einträge pro Seite mit {current} von {total} angezeigt",
  page: "Seite",
  pageOf: "von {page}"
};
